import { Injectable } from '@angular/core'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult, mapData } from '@ftr/foundation'
import { CourtroomRealTimeSttConfiguration, CourtroomRealTimeSttConfigurationSchema } from '@ftr/regional-api-contracts'
import { switchMap } from 'rxjs'
import { RegionalApiClientSetupService } from '../api-client'

interface GetConfigurationArgs {
  locationId: Uuid
  courtSystemId: Uuid
}
@Injectable({
  providedIn: 'root',
})
export class CourtroomRealTimeSttConfigurationService extends RegionalApiClientSetupService {
  override regionalApiPath = 'courtroom-real-time-stt-configuration'

  save(
    configuration: CourtroomRealTimeSttConfiguration,
    { courtSystemId, locationId }: GetConfigurationArgs,
  ): ApiResult<CourtroomRealTimeSttConfiguration> {
    return this.regionalApiClient(this.regionalApiPath, courtSystemId).pipe(
      switchMap(client =>
        client.put({
          headers: { courtSystemId },
          path: `/${locationId}`,
          body: configuration,
        }),
      ),
      mapData(() => configuration),
    )
  }

  get({ courtSystemId, locationId }: GetConfigurationArgs): ApiResult<CourtroomRealTimeSttConfiguration> {
    return this.regionalApiClient(this.regionalApiPath, courtSystemId).pipe(
      switchMap(client =>
        client.get({
          headers: { courtSystemId },
          path: `/${locationId}`,
          responseBodyParser: CourtroomRealTimeSttConfigurationSchema,
        }),
      ),
    )
  }
}
